import { render, staticRenderFns } from "./GiftsetTemplateDashboard.vue?vue&type=template&id=4220f512"
import script from "./GiftsetTemplateDashboard.vue?vue&type=script&lang=js"
export * from "./GiftsetTemplateDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports